/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".callout_98b6c642 .ms-Suggestions-itemButton{padding:0;border:none}.callout_98b6c642 .ms-Suggestions{min-width:300px}" }]);
export var callout = "callout_98b6c642";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map